import { pathJoin } from 'src/reducers/routing/utils'

export const createKmdEasyImportFilesDetailViewRoutesMap = (
  prefix: string
) => ({
  view: pathJoin(prefix)('view').chain,
})
